import { useEffect, useRef } from "react";

interface VersionResponse {
  version: string;
}

import { VERSION_CHECK_INTERVAL_MS as CHECK_INTERVAL } from "@/shared/config/app";

const AppVersionChecker = () => {
  const currentVersionRef = useRef<string | null>(null);

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval>;

    const checkForNewVersion = async () => {
      try {
        const response = await fetch(`/version.json?timestamp=${Date.now()}`, {
          cache: "no-store",
        });

        if (!response.ok) {
          return;
        }

        const data: VersionResponse = await response.json();

        // First check: store the currently running version
        if (currentVersionRef.current === null) {
          currentVersionRef.current = data.version;
          return;
        }

        // New deployment detected
        if (currentVersionRef.current !== data.version) {
          console.log("New application version detected. Reloading...");

          window.location.reload();
        }
      } catch (error) {
        console.error("Failed to check application version:", error);
      }
    };

    // Check immediately when the application loads
    checkForNewVersion();

    // Check every 30 seconds
    intervalId = setInterval(checkForNewVersion, CHECK_INTERVAL);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return null;
};

export default AppVersionChecker;
